import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import CalendarBlackIcon from '../../../../../../assets/svg/calendarBlack.svg?react';

interface SelectDateComponnentProps {
  selected: string;
  setSelected: (value: string) => void;
  disabled: boolean;
  width?: string;
}
const SelectDateComponent = ({
  selected,
  setSelected,
  disabled,
  width,
}: SelectDateComponnentProps) => {
  const handleChangeDate = (date: string) => {
    setSelected(date);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DesktopDatePicker
        disabled={disabled ? true : false}
        minDate={dayjs(Date.now())}
        sx={{
          borderWidth: '0px',
          bgcolor: '#00000008',
          width: width ? width : '100%',
          borderRadius: '6px',
          padding: '8px 12px',
          paddingRight: '25px',
          '.Mui-error': {
            borderColor: 'blue!important',
          },
          ...(!isNaN(new Date(selected).getDate()) && {
            '& .MuiFormLabel-root': {
              fontSize: '12px',
              color: 'black',
            },
            backgroundColor: 'white',
            border: '1px solid rgba(0, 0, 0, 0.50)',
            '&:hover': {
              backgroundColor: 'white',
            },
          }),
        }}
        value={dayjs(selected)}
        onChange={(e) => {
          if (e) {
            handleChangeDate(e.format());
          }
        }}
        slotProps={{
          textField: {
            error: false,
            variant: 'standard',
            InputProps: {
              disableUnderline: true,
            },
          },
        }}
        slots={{
          openPickerIcon: CalendarBlackIcon,
        }}
      />
    </LocalizationProvider>
  );
};

export default SelectDateComponent;
